import React, { useState } from 'react';
import { useRegister } from '../../../../hooks/register';
import { Container, PolicyImg, Title, Description, CheckboxContainer, Checkbox, Label } from './styles';
import Button from '../../../Button';

const PolicySignUp: React.FC = () => {
  const { handleStep, userData, handleData } = useRegister();
  const [acceptTerms, setAcceptTerms] = useState(userData?.acceptTerms || false);

  const handleChange = (e: any) => {
    const { checked } = e.target;
    setAcceptTerms(checked);
    handleData({ acceptTerms: checked });
  };

  return (
    <Container>
      <PolicyImg />
      <Title>Nos preocupamos com a segurança dos seus dados.</Title>
      <Description>
        Por isso, adotamos as diretrizes de transparência e conformidade com as obrigações previstas na Lei Geral de
        Proteção de Dados.
      </Description>

      <CheckboxContainer>
        <Checkbox checked={acceptTerms} id="policy-checkbox" onChange={handleChange} />
        <Label htmlFor="policy-checkbox">
          Eu li e estou de acordo com os{' '}
          <a rel="noreferrer" target="_blank" href="https://privacidade.allya.com.br/termos-de-uso">
            Termos de Uso
          </a>{' '}
          e a{' '}
          <a rel="noreferrer" target="_blank" href="https://privacidade.allya.com.br/politica-de-privacidade">
            Política de Privacidade
          </a>{' '}
          da Allya.
        </Label>
      </CheckboxContainer>

      <Button
        disabled={!acceptTerms}
        title="Continuar"
        classType="fat big"
        onClick={() => handleStep('companySelection')}
      />
    </Container>
  );
};

export default PolicySignUp;
